import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  ProvideKeycloakOptions,
  UserActivityService,
  withAutoRefreshToken
} from 'keycloak-angular';

const localhostCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /^(https:\/\/connect-applications-api.azurewebsites.net)(\/.*)?$/i
});

// Add here your keycloak setup infos
let keycloakConfig: ProvideKeycloakOptions = {
  config: {
    url: 'https://auth.connect-sos.com',
    realm: 'EmisionSantander',
    clientId: 'connect-principle-ui'
  },
  initOptions: {
    onLoad: 'login-required',
    checkLoginIframe: false,
    redirectUri: window.location.origin + '/home'
  },
  features: [
    withAutoRefreshToken({
      onInactivityTimeout: 'logout',
      sessionTimeout: 60000
    })
  ],
  providers: [
    AutoRefreshTokenService,
    UserActivityService,
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [localhostCondition]
    }
  ]
};


export const environment = {
  production: false,
  baseUrl:'https://connect-applications-api.azurewebsites.net/api/insurance/applications/v1',
  keycloak: keycloakConfig
};
